/**
 * User: WangMeng
 * Date: 2018-07-18
 * Time: 15:48
 * Desc: 担保金额较大
 */

import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class AmountGuaranteed extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '担保金额（元）';
    }

    getColumns = () => {
        return [{
            title: '担保金额',
            dataIndex: 'guarBalance'
        }, {
            title: '关联担保余额',
            dataIndex: 'relateGuarBalance'
        }, {
            title: '担保总额占净资产比例',
            dataIndex: 'percent'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/AmountGuaranteed.jsx